import { createPortal } from "react-dom";

/**
 * Overlay padrão Simpler: renderiza no <body> para cobrir a tela inteira
 * (cabeçalho, sidebar, conteúdo e rodapé), independente de onde é usado.
 */
export default function ScreenOverlay({ children }) {
  if (typeof document === "undefined") return children;
  return createPortal(children, document.body);
}
